import { useEffect } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function ZoomImageSection({ imagepath }) {
 
  useEffect(() => {
    const img = new Image();
    img.src = imagepath;
    const widthRatio = img.naturalWidth / img.naturalHeight
    if(widthRatio < 1){
      const imageBody = document.querySelector(".ZoomImageDrawer .image-body")
      if(imageBody){
        imageBody.classList.remove("zoom_cover")
      }
    }
  }, [])

  return (
    
      <TransformWrapper initialScale={1} maxScale={window.innerWidth > 768 ? 1 : 2}>
        <TransformComponent>
          {
            imagepath.includes(".mp4") ? (
              <video
                    muted
                    className={"zoom-img"}
                    width={"100%"}
                    controls={false}
                    autoPlay={true}
                    playsInline
                    style={{
                      aspectRatio: "15/15",
                      objectFit: "contain",
                      cursor: "pointer",
                      // objectPosition: "top",
                    }}
                    loop
                    src={imagepath}
                    
                    // poster={`${cdn}uploads/default_image/${default_image}`}
                  ></video>
            ) : (

              <img src={`${imagepath}`} alt={"zoom-img"} className="zoom-img" />
            )
          }
        </TransformComponent>
      </TransformWrapper>
    
  );
}

export default ZoomImageSection;
